// 通用接口列表
import { httpPost, httpPostJson } from '@/utils/request';

export const fetchDistrict = () => httpPost('/api/sys/district/cn'); // 获取中国省市区
export const fetchCountryList = () => httpPost('/api/sys/district/country'); // 获取国家列表
export const fetchAreaList = (params: any) => httpPost('/api/sys/district/data',params); // 国家地区列表
export const fetchIndustryAndSubCategory = () => httpPost('/api/conf/industry/class23'); // 客户行业--细分品类
export const fetchTargetRegion = () => httpPost('/api/conf/target_region/list'); // 推广区域
export const fetchTargetRegionV2 = () => httpPost('/api/conf/target_region/list/v2'); // 推广区域--v2版本

export const fetchIndustry = () => httpPost('/api/conf/industry/class2'); //客户行业
export const fetchCategory = () => httpPost('/api/conf/industry/class3'); // 细分品类

export const fetchUnderlingList = () => httpPost('/api/sys/user/underling'); // 下属负责人列表

export const fetchReportFollowupView = (params: any) => httpPostJson('/api/reports/follow_up_view', params); // 获取报告跟进记录view
export const fetchReportCustomerView = (params: any) => httpPostJson('/api/reports/customer_view', params); // 获取customer view
export const fetchReportOpptyView = (params: any) => httpPostJson('/api/reports/oppty_view', params); // 获取oppty view
export const fetchReportOpptyStageView = (params: any) => httpPostJson('/api/reports/oppty_stage_view', params); // 获取oppty stage view
export const fetchReportLeadView = (params: any) => httpPostJson('/api/reports/leads_view', params); // lead view
export const fetchJobList = (params: any) => httpPost('/api/datadumpjob/list', params);
export const addFollowupRemind = (params: any) => httpPost('/api/followupremind/remind_add', params);
export const getWeekReport = (params: any) => httpPost('/api/conf/get_week_report', params);
export const quickEdit = (params: any) => httpPost('/api/common/quick_edit', params);